module.exports = __webpack_public_path__ + "static/media/survey.8d7ed277.png";